export const newObjectId = -1